import React from 'react';
import { Box, Button, CloseButton, Image, Text, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import wifiImg from '../../../assets/images/wifi.svg';
import { MANUFACTURER_ID_SATURN } from '../../devices/devices-helper';
import { selectCellularModems, selectInverters, selectSite } from '../../site/siteSlice';

export function InverterWifiSetupAlert() {
  const { t } = useTranslation();
  const { site_id: siteId } = useSelector(selectSite);
  const navigate = useNavigate();
  const siteHasCellularModem = !!useSelector(selectCellularModems)?.length;
  const skipWifiCommissioning = localStorage.getItem(`skipInverterWifiCommissioning_${siteId}`) === 'true';
  const saturnInverter = useSelector(selectInverters).find((device) =>
    [MANUFACTURER_ID_SATURN].includes(device.manufacturer_id)
  );
  const defaultIsOpen = siteHasCellularModem && !!saturnInverter && skipWifiCommissioning;
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen });

  const handleClose = () => {
    localStorage.setItem(`skipInverterWifiCommissioning_${siteId}`, 'false');
    onClose();
  };

  const handleWifiSetup = () => {
    localStorage.setItem(`skipInverterWifiCommissioning_${siteId}`, 'false');
    navigate(
      `../account/hardware/configure/inverter/power_up_instructions?shouldRegisterDevice=false&deviceId=${saturnInverter?.id}&direction=forward`
    );
  };

  return isOpen ? (
    <Box
      bg="#EEEEEE"
      color="#111111"
      p={3}
      pl="66px"
      pr="26px"
      borderRadius="sm"
      mb={4}
      position="relative"
      data-testid="inverter-wifi-setup"
    >
      <Box
        borderLeftRadius="sm"
        bg="orange.400"
        height="100%"
        width="50px"
        position="absolute"
        left="0"
        top="0"
        alignContent="center"
        justifyItems="center"
      >
        <Image src={wifiImg} alt="wifi" />
      </Box>
      <CloseButton
        size="sm"
        position="absolute"
        right="4px"
        top="4px"
        onClick={handleClose}
        data-testid="inverter-wifi-setup-close-button"
      />
      <Text fontWeight="bold" mb={1}>
        {t('Home Screen.cellular notification.title')}
      </Text>
      <Text>{t('Home Screen.cellular notification.subtitle')}</Text>
      <Button
        variant="link"
        size="md"
        color="schneiderSkyBlue.200"
        fontWeight={400}
        display="block"
        marginLeft="auto"
        onClick={handleWifiSetup}
        data-testid="inverter-wifi-setup-button"
      >
        {t('Home Screen.cellular notification.button')}
      </Button>
    </Box>
  ) : null;
}
